export default "/_next/static/images/8477a30c6f22b5788c2907d85f829f1b.jpg";